import { render, staticRenderFns } from "./TestItemCalculation.vue?vue&type=template&id=1269150f&scoped=true&"
import script from "./TestItemCalculation.vue?vue&type=script&lang=js&"
export * from "./TestItemCalculation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1269150f",
  null
  
)

export default component.exports